<template>
  <div class="vehicles-filter-section">
    <navigation-button
      class="vehicles-filter-button"
      icon="plus"
      label="Adicionar veículo"
      :href="href"
    />

    <navigation-button
      class="vehicles-filter-button"
      :color="color"
      :icon="icon"
      :label="label"
      @click="toggle"
    />
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  import NavigationButton from '@/components/Navigation/Button.vue';

  export default {
    name: 'VehiclesListFilter',
    components: {
      NavigationButton,
    },
    computed: {
      ...mapState([
        'vehicleModels',
      ]),

      href() {
        return {
          name: this.$route.meta.new,
        };
      },

      active() {
       return this.vehicleModels.list.filters.show;
      },
      icon() {
        return this.active ? 'times' : 'filter';
      },
      color() {
        return this.active ? 'red' : 'gray';
      },
      label() {
        return this.active ? 'Limpar filtros' : 'Filtros';
      },
    },
    methods: {
      toggle() {
        this.$store.dispatch('vehicleModels/filter', {
          ...this.vehicleModels.list.filters,
          show: !this.vehicleModels.list.filters.show,
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .vehicles-filter-section {
    align-items: stretch;
    display: flex;
    gap: 1em;
    flex-direction: column;
    justify-content: flex-end;
    min-width: $button;
    margin: 0 var(--product--pwa--horizontal) $gutter;

    @media all and (min-width: $breakpoint-desktop) {
      align-items: flex-start;
      flex-direction: row;
    }
  }
</style>
